module.exports = [
    { "label": "Leave Details", "value": "LeaveDetails" },
    { "label": "Pre", "value": "Pre" },
    { "label": "Post", "value": "Post" },
    { "label": "Feedback", "value": "Feedback" },
    { "label": "Group Booking", "value": "GroupBooking" },
    { "label": "Long Stay", "value": "LongStay" },
    { "label": "Lost & Found", "value": "LostFound" },
    { "label": "Invoice Request", "value": "InvoiceRequest" },
    { "label": "In Stay", "value": "InStay" },
    { "label": "Check-In", "value": "CheckIn" }
]